import { IconContent } from '@icons';

export const census: IconContent = {
    md: '<path fill-rule="evenodd" d="M6 4h12v7.083a5.95 5.95 0 0 1 1 .258V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h6.528a6.018 6.018 0 0 1-.725-1H6V4Zm13.453 16.16a4 4 0 1 1 .707-.707l3.194 3.194-.708.707-3.193-3.194ZM20 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM16 6H8v1h8V6ZM8 8h8v1H8V8Zm5 2H8v1h5v-1Z" />',
};
